import {
	white,
	lightGray,
	lightGray2,
	lightGray3,
	darkGray,
	lightBlue,
	midBlue,
	limeGreen,
	darkRed,
} from '../../../../colors';

export default {
	dialogPaper: {
		overflowY: 'hidden',
		maxWidth: '600px',
	},
	dialogTitle: {
		padding: '16px 24px',
	},
	dialogContent: {
		padding: '24px',
		minHeight: '200px',
	},
	dialogActions: {
		padding: '16px 24px',
		justifyContent: 'flex-end',
	},
	sleeperCard: (selected) => ({
		cursor: 'pointer',
		border: selected ? `2px solid ${midBlue}` : `1px solid ${lightGray}`,
		backgroundColor: selected ? lightBlue : white,
		marginBottom: '8px',
	}),
	sleeperCardContent: {
		padding: '16px',
		'&:last-child': {
			paddingBottom: '16px',
		},
	},
	priceTypography: {
		fontWeight: 'bold',
		fontSize: '1rem',
	},
	descriptionTypography: {
		color: darkGray,
		marginTop: '4px',
	},
	accordionSummary: {
		background: `linear-gradient(${lightGray2}, ${lightGray3})`,
		marginBottom: '15px',
		fontWeight: 500,
	},
	availabilityContainer: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: '8px',
	},
	availabilityChip: (availability) => ({
		fontSize: '0.75rem',
		height: '22px',
		backgroundColor: availability <= 3 ? darkRed : limeGreen,
		color: 'white',
		fontWeight: 'bold',
	}),
};
